<div style="padding: 0.2rem">
    <article class="well well-sm">
        <header class="tt-webpagemenu-group__header">
            <h3 class="tt-webpagemenu-group__heading">{{ get?.labour_name }}</h3>
            <!-- <button *ngIf="widgetItem?.expandable !== false" class="group-header__expand" (click)="toggleExpansion()">
                <span class="far fa-chevron-up" [style.transform]="!widgetItem?.expanded ? 'rotate(180deg)' : undefined"></span>
            </button> -->
        </header>
        <div *ngIf="!!get" style="height: fit-content; display: flex; flex-direction: column; flex-shrink: 0">
            <!-- <tt-input class="col-xs-12 sp-0" ttLabel="labour_name" [ttModel]="get.labour_name" ttReadonly></tt-input> -->
            <!-- <tt-input class="col-xs-12 sp-0" ttLabel="labour_no" [ttModel]="get.labour_no" ttReadonly></tt-input> -->
            <tt-input class="col-xs-12 sp-0" ttLabel="relatives_name" [(ttModel)]="get.relatives_name"></tt-input>
            <tt-input class="col-xs-12 sp-0" ttLabel="relatives_telephone" [(ttModel)]="get.relatives_telephone"></tt-input>
            <tt-button-save ttText="mypage_save" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
        </div>
    </article>
</div>
